import useSetFullscreen from "@modules/app/hooks/useSetFullscreen"

const FullScreen = () => {
  useSetFullscreen()
  return <></>
}

export default FullScreen
